module.exports = __webpack_public_path__ + "static/media/b.538124ed.png";